import { RingProgress } from '../common/RingProgress';
import { EmergencyFundTermHint } from './EmergencyFundTermHint';
import pt from '../../locales/pt';
import { RECOMMENDED_MONTHS, formatMonths } from '../../lib/emergencyFundDisplayUtils';

/**
 * `.pen` → `ds/chart/ring-progress--lg` (`R8wy8`, 132×132), instanciado como
 * `ring` dentro de `ds/card/emergency-peace` (`K9DGt`). Anel **completo**
 * (`startAngle` 90, sweep negativo) — deixou de ser o arco de ¾ do desenho
 * antigo. O centro fica com meses cobertos + rótulo; a linha «de N meses
 * (meta)» vive no `head` do cartão, não aqui.
 */
export function EmergencyFundPeaceRing({
  monthsCovered,
  targetMonths,
  isLoading = false,
  className,
}) {
  const covered = Math.max(0, Number(monthsCovered ?? 0));
  const target = Math.max(1, Number(targetMonths ?? RECOMMENDED_MONTHS));
  const percent = Math.min(100, (covered / target) * 100);
  const copy = pt.emergencyFund.dashboard.peace;

  return (
    <RingProgress
      size="lg"
      percent={percent}
      state={isLoading ? 'loading' : covered > 0 ? 'default' : 'empty'}
      ariaLabel={`${formatMonths(covered)} ${copy.monthsLabel}`}
      className={className}
    >
      <span className="type-display-hero text-sage-700 dark:text-sage-300">
        {formatMonths(covered)}
      </span>
      <span className="type-label flex items-center gap-space-1 font-semibold text-muted-foreground">
        {copy.monthsLabel}
        <EmergencyFundTermHint term="monthsCoverage" variant="icon" />
      </span>
    </RingProgress>
  );
}

export default EmergencyFundPeaceRing;
